import { render, staticRenderFns } from "./RegistraElementi.vue?vue&type=template&id=0563080c&scoped=true&"
import script from "./RegistraElementi.vue?vue&type=script&lang=js&"
export * from "./RegistraElementi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563080c",
  null
  
)

export default component.exports